<div class="row">
  <div class="col-md-12">


    <div class="box box-primary box-dark">

      <div class="box-body">

        <div class="box-header text-center">
          <h3 class="box-title ">Cadastrar PT</h3><br />
        </div>

       <!--  <nav class="navbar navbar-expand-lg navbar-light bg-light pr-1">
          <span class="navbar-brand"><i class="lnr-cog"></i></span>
          <button class="navbar-toggler" type="button"> </button>
          <div class="collapse navbar-collapse tabs-animated tabs-animated-shadow" id="navbarNav"> -->
         <!--    <ul class="navbar-nav mr-auto"> -->
              <!-- <li class="nav-item mr-2">
                <button class="btn btn-shadown" [ngClass]="{'btn-primary dark' : isNovoCadastro}" type="button"
                  [routerLink]="['cadastrar', '']">
                  <i class="fa fa-plus mr-2"></i> Cadastro PT
                </button>
              </li> -->

             <!--  <li class="nav-item">
                <button class="btn btn-shadown" type="button" [ngClass]="{'btn-primary dark' :!isNovoCadastro}"
                  routerLink="lista">
                  <i class="fa fa-list mr-2"></i> Lista de PTs
                </button>
              </li> -->


           <!--  </ul> -->
           

         <!--  </div>
        </nav> -->

        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>

